import { Controller } from "@hotwired/stimulus"

// The equipment list only applies to a profile that answered "Show equipment",
// so it stays hidden until that is picked.
export default class extends Controller {
  static targets = ["choice", "fields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const listing = this.choiceTargets.some((choice) => choice.checked && choice.value === "true")

    this.fieldsTarget.classList.toggle("hidden", !listing)

    // Hiding alone is not enough — hidden inputs still serialize, which would
    // save an equipment list for a profile that has answered "No".
    this.fieldsTarget.querySelectorAll("input, textarea").forEach((field) => {
      field.disabled = !listing
    })
  }
}
